import type { PageContext } from '../lib/types';
import { html } from '../lib/dom';
import { icon } from '../components/icons';

const sections = [
  { title: 'Brands', description: 'Manage brand identity and assets.', href: '#/brands', icon: 'brands' },
  { title: 'Assets', description: 'Browse files and generated content.', href: '#/assets', icon: 'archive' },
  { title: 'Workspaces', description: 'Manage shared creative spaces.', href: '#/workspaces', icon: 'workspaces' },
  { title: 'Projects', description: 'Organize flows and project assets.', href: '#/projects', icon: 'projects' },
  { title: 'Flows', description: 'Build and run creative workflows.', href: '#/flows', icon: 'node' },
  { title: 'Executions', description: 'Review workflow execution history.', href: '#/executions', icon: 'runs' },
  { title: 'Gallery', description: 'Discover community creations.', href: '#/gallery', icon: 'gallery' },
  { title: 'Marketplace', description: 'Explore and share flow templates.', href: '#/marketplace', icon: 'tag' },
  { title: 'Settings', description: 'Configure your organization.', href: '#/settings', icon: 'settings' },
];

export function render(_ctx: PageContext) {
  return {
    title: 'Overview',
    body: html`<div class="page">
      <header class="page-head"><div><div class="eyebrow">Studio</div><h1>Overview</h1><p class="muted">Choose a section to get started.</p></div></header>
      <section class="section"><div class="grid c2">${sections.map(section => html`<a class="card hover pad" href="${section.href}">
        <div class="col" style="gap:6px"><h2 style="font-size:16px">${icon(section.icon)} ${section.title}</h2><p class="muted" style="font-size:13px">${section.description}</p></div>
      </a>`)}</div></section>
    </div>`,
  };
}
